<div>
  <div class="header rounded-lg flex flex-row items-center top-0 asset-details z-50">
    <div class="title w-3/5 font-bold text-xl" i18n>MOST POPULAR</div>
    <div class="actions w-2/5 text-right"></div>
  </div>
  <div class="popular-assets">
    <div class="h-full pt-3">
      <div class="w-full">
        <!-- To show loading message, while http call is in progress -->
        <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
        <ng-template #loadingComplete>
          <ng-container *ngIf="basketDataLoaded && assetsData.length">
            <thehubz-asset-dashboard-card-view [assets]="assetsData"></thehubz-asset-dashboard-card-view>
          </ng-container>
          <ng-container *ngIf="basketDataLoaded && !assetsData.length" class="pr-3 overflow-hidden !h-40">
            <p i18n>No assets available</p>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
